import Ajv from 'ajv';
export const getValidator = (schema, options = undefined) => {
    const ajv = new Ajv(Object.assign({ strict: false, allErrors: true, useDefaults: true }, (options !== null && options !== void 0 ? options : {})));
    let validator;
    try {
        validator = ajv.compile(schema);
    }
    catch (error) {
        console.error('[KaotoForm Validator]: Could not compile schema', error);
    }
    return validator;
};
//# sourceMappingURL=get-validator.js.map